import styled from 'styled-components';

import {getColor, gts, ms} from '../../../../../../styles';
import {Clickable} from '../../../../../../uikit/Clickable';
import {Icon} from '../../../../../../uikit/Icon';
import {Text} from '../../../../../../uikit/Text';
import {TextArea} from '../../../../../../uikit/TextArea';
import {View} from '../../../../../../uikit/View';

export const Container = styled(View)`
  flex: 1;
  flex-direction: column;
  gap: ${gts('gap.xl')};
`;

export const RowBlock = styled(Container)`
  flex-direction: row;
`;

export const RightColumn = styled(View)`
  flex: 1;
  flex-direction: column;
  gap: ${gts('gap.xl')};
  min-width: 0;
`;

export const CommentInputWrapper = styled(View)`
  position: relative;
`;

export const CommentInput = styled(TextArea)`
  min-height: ${ms(102)};
  padding-right: ${ms(30)};
  resize: none;
`;

export const SendButton = styled(Clickable)`
  position: absolute;
  bottom: ${ms(20)};
  right: ${ms(20)};
`;

export const SendIcon = styled(Icon)``;

export const Block = styled(View)`
  flex-direction: column;
  background-color: ${getColor('background.white')};
  border-radius: ${gts('borderRadius.xl')};
  padding: ${gts('padding.xxl')};
  gap: ${gts('gap.xxl')};
  min-width: ${ms(400)};
  height: ${ms(334)};
`;

export const ReportingBlock = styled(Block)<{$isExpanded?: boolean}>`
  flex: 1;
  ${p =>
    !p.$isExpanded &&
    `
    flex: 0 0 auto;
    height: fit-content;
  `};
`;

export const CommentBlock = styled(Block)`
  flex: 0 0 auto;
  height: fit-content;
`;

export const ChartContainer = styled(View)`
  min-height: 0;
  flex: 1;
`;

export const OptionsContainer = styled(View)`
  gap: ${gts('gap.me')};
`;

export const Row = styled(View)`
  justify-content: space-between;
  align-items: center;
`;

export const OptionsWrapper = styled(Row)`
  gap: ${ms(20)};
`;

export const DateContainer = styled(View)`
  padding-top: ${ms(5)};
`;

export const Weight = styled(View)`
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  gap: ${gts('gap.me')};
  border-radius: ${gts('borderRadius.la')};
`;

export const TextContainer = styled(Weight)`
  justify-content: center;
  align-items: center;
  background-color: ${getColor('#F2F5F6')};
`;

export const TextWrapper = styled(View)`
  text-align: center;
  max-width: ${ms(240)};
`;

export const IconContainer = styled(View)`
  flex-direction: row;
  align-items: center;
  gap: ${ms(5)};
`;

export const CommentContainer = styled(View)`
  flex-direction: column;
  gap: ${gts('gap.xl')};
`;

export const CommentItem = styled(View)`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Comment = styled(View)`
  flex-direction: column;
  gap: ${gts('gap.xs')};
`;

export const CommentDate = styled(Text).attrs({
  variant: 'subtitle',
  weight: 'semibold',
})`
  color: ${getColor('text3')};
`;

export const CommentContent = styled(Text).attrs({
  variant: 'h3',
  weight: 'regular',
})`
  font-weight: 400;
`;
